import { BottomNav } from './components';
import { ReactNode } from 'react';
import { ChildrenProps } from '@cotera/client/app/components/utils';

export interface LayoutProps {
  skipPadding?: boolean;
  actions?: ReactNode[];
  children: ReactNode | ReactNode[];
  mainClassName?: string;
  loading?: boolean;
  bottomNav?: () => ChildrenProps['children'];
  scroll?: boolean;
}

export const LegacyLayout: React.FC<
  LayoutProps & {
    showTopNav?: boolean;
  } & React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >
> = ({ children, bottomNav, scroll = true }) => {
  return (
    <div className="h-full w-full py-4 flex flex-col">
      <div className={`flex-1 ${scroll ? 'overflow-y-auto' : ''}`}>
        {children}
      </div>
      {bottomNav && <BottomNav.Container>{bottomNav()}</BottomNav.Container>}
    </div>
  );
};
